import React from 'react';
import { backEnvelopeStatusToFront, frontEnvelopeStatusToStyle, backSignerStatusToFront, frontSignerStatusToStyle, backSignerBatchStatusToFront, frontSignerBatchStatusToStyle } from '../utils/utils';

function StatusIconText (props) {
  
  const { id, status, rule_analysis_status, type } = props

  let frontStatus
  let statusStyle

  if (type==="signer_status") {
    if(rule_analysis_status === 'in_manual_analysis'){
      frontStatus = backSignerStatusToFront[rule_analysis_status]
      statusStyle = frontSignerStatusToStyle[frontStatus]
    } else if( rule_analysis_status === 'reproved') {
      frontStatus = backSignerStatusToFront[rule_analysis_status]
      statusStyle = frontSignerStatusToStyle[frontStatus]
    } else {
      frontStatus = backSignerStatusToFront[status]
      statusStyle = frontSignerStatusToStyle[frontStatus]
    }
  }
  else if (type==="envelope_status") {
    if(rule_analysis_status === 'in_manual_analysis'){
      frontStatus = backEnvelopeStatusToFront[rule_analysis_status]
      statusStyle = frontEnvelopeStatusToStyle[frontStatus]
    } else {
      frontStatus = backEnvelopeStatusToFront[status]
      statusStyle = frontEnvelopeStatusToStyle[frontStatus]
    }

    
  }
  else if (type==="signer_batch_status") {
    frontStatus = backSignerBatchStatusToFront[status]
    statusStyle = frontSignerBatchStatusToStyle[frontStatus]
  }

  return (
    <div id={id?id:null} style={{padding: '5px 5px'}} className={([statusStyle.backgroundColor]&&[statusStyle.backgroundColor])+" status-icon-text"}>
      {statusStyle.icon?statusStyle.icon:null}
      <p id={id?id:null}>
        {statusStyle.text?statusStyle.text:status}
      </p>
    </div>
  )
}

export default StatusIconText;
